module.exports = "//static.hsappstatic.net/LoginUI/static-1.15699/img/passkey-logo.svg"